import axios from "axios";
import Cookies from 'js-cookie'
import { apiUrl } from './ApiHost';

class AuthService {
  login(username, password) {
    return axios
      .post(apiUrl + "auth/login", { username, password })
      .then((response) => {
        if (response.data.jwt) {
          Cookies.set("user", JSON.stringify(response.data), { path: '', sameSite: "None", secure: true })
        }

        return response.data;
      }).finally(() => {
        const user = JSON.parse(Cookies.get("user"));
        let isAssistant = this.getHighestRole() === "ASSISTANT";
        if (user && user.jwt && isAssistant) {
          window.location.href = `#/home/invite`
        } else if (user && user.jwt) {
          window.location.href = `#/home/dashboard`
        }
      });
  }

  getRoles() {
    const user = JSON.parse(Cookies.get("user"));
    return user["roles"]
  }

  hasAnyRole(roles) {
    let userRoles = this.getRoles()
    let hasAny = false;
    roles.forEach(role => {
      if (userRoles.indexOf(role) !== -1)
        hasAny = true
    });
    return hasAny
  }

  getHighestRole() {
    if (this.hasAnyRole(["ADMIN"]))
      return "ADMIN"
    if (this.hasAnyRole(["EMPLOYEE"]))
      return "EMPLOYEE"
    if (this.hasAnyRole(["ASSISTANT"]))
      return "ASSISTANT"
  }


  logout() {
    Cookies.remove("user", { path: '' })
    window.location.href = `#/`;
  }
}

export default new AuthService();